import { DateTime } from "luxon";
import {
  holidays2025,
  holidays2026,
  holidays2027,
  SchedulePublicHolidayType,
  type SchedulePublicHolidays
} from "../../../components/Schedule/schedule-calendar-holidays";

const DASHBOARD2_HOLIDAY_YEARS = [2025, 2026, 2027];

const DASHBOARD2_PUBLIC_HOLIDAYS: SchedulePublicHolidays[] = [
  ...holidays2025,
  ...holidays2026,
  ...holidays2027
].filter(
  holiday =>
    holiday.type === SchedulePublicHolidayType.FEDERAL ||
    holiday.states.includes("Berlin") ||
    holiday.states.includes("Hesse")
);

const currentYear = DateTime.now().year;

if (!DASHBOARD2_HOLIDAY_YEARS.includes(currentYear)) {
  console.warn(
    `[Dashboard2] Public holiday data does not cover the current year (${currentYear}). ` +
      `Loaded years: ${DASHBOARD2_HOLIDAY_YEARS.join(", ")}. Add the missing year to dashboard2-public-holidays.utils.ts.`
  );
}

export function getPublicHolidayNameForDay(day: DateTime, language: string): string | undefined {
  const dayKey = day.toFormat("yyyy-MM-dd");
  const holiday = DASHBOARD2_PUBLIC_HOLIDAYS.find(entry => entry.date === dayKey);

  if (!holiday) {
    return undefined;
  }

  return language === "de" ? holiday.names.de : holiday.names.en;
}
